import {
  Users,
  LayoutDashboard,
  Gauge,
  FileText,
  MapPin,
  Phone,
  Tag,
  ImageIcon,
  Eye,
  Store,
  Calendar,
  ArrowLeft,
  Package,
  Activity,
  Lightbulb,
  Download,
  Inbox,
  Flag,
  Sparkles,
  BookOpen,
  
  Bug,
  HeartPulse,
  Trash2,
} from 'lucide-react';
import type { NavConfig } from './nav.types';

/**
 * Global admin navigation (no producer context)
 */
export const adminNav: NavConfig = [
  {
    title: 'Administration',
    items: [
      {
        label: 'Kontrollpanel',
        href: '/app/admin/control-panel',
        icon: Gauge,
      },
      {
        label: 'Översikt',
        href: '/app/admin/dashboard',
        icon: LayoutDashboard,
      },
      {
        label: 'Värdar',
        href: '/app/admin/producers',
        icon: Users,
        children: [
          {
            label: 'Alla värdar',
            href: '/app/admin/producers',
            icon: Users,
            exact: true,
          },
          {
            label: 'Success',
            href: '/app/admin/producers/success',
            icon: Sparkles,
          },
          {
            label: 'Ansökningar',
            href: '/app/admin/producer-interest',
            icon: Inbox,
            badgeKey: 'newApplications',
          },
        ],
      },
      {
        label: 'Platser',
        href: '/app/admin/places',
        icon: MapPin,
        children: [
          {
            label: 'Alla platser',
            href: '/app/admin/places',
            icon: MapPin,
            exact: true,
          },
          {
            label: 'Platsimport',
            href: '/app/admin/places/ingest',
            icon: Download,
          },
          {
            label: 'Platsförslag',
            href: '/app/admin/place-suggestions',
            icon: Lightbulb,
            badgeKey: 'newPlaceSuggestions',
          },
          {
            label: 'Rapporter',
            href: '/app/admin/places/reports',
            icon: Flag,
            badgeKey: 'newPlaceReports',
          },
        ],
      },
      {
        label: 'Systemloggar',
        href: '/app/admin/system-logs',
        icon: Activity,
      },
      {
        label: 'Host Health',
        href: '/app/admin/system/host-health',
        icon: HeartPulse,
      },
      {
        label: 'Host Debug',
        href: '/app/admin/system/host-debug',
        icon: Bug,
      },
      {
        label: 'E-postkö',
        href: '/app/admin/email-outbox',
        icon: Inbox,
      },
      {
        label: 'Legal documents',
        href: '/app/admin/legal/producer-terms',
        icon: FileText,
      },
      {
        label: 'Utkast-cleanup',
        href: '/app/admin/cleanup/drafts',
        icon: Trash2,
      },
    ],
  },
  {
    title: 'Redaktion',
    items: [
      {
        label: 'Områden',
        href: '/app/admin/areas',
        icon: MapPin,
      },
      {
        label: 'Upplevelser',
        href: '/app/admin/experiences',
        icon: Sparkles,
      },
      {
        label: 'Ambassadörer',
        href: '/app/admin/ambassadors',
        icon: Users,
      },
    ],
  },
];

/**
 * Admin navigation when viewing/editing a specific producer
 */
export function getAdminProducerNav(producerId: string): NavConfig {
  return [
    {
      title: 'Navigering',
      items: [
        {
          label: 'Alla värdar',
          href: '/app/admin/producers',
          icon: ArrowLeft,
          exact: true,
        },
      ],
    },
    {
      title: 'Värd',
      items: [
        {
          label: 'Översikt',
          href: `/app/admin/producers/${producerId}`,
          icon: LayoutDashboard,
          exact: true,
        },
        {
          label: 'Grundinfo',
          href: `/app/admin/producers/${producerId}/grundinfo`,
          icon: FileText,
        },
        {
          label: 'Plats',
          href: `/app/admin/producers/${producerId}/plats`,
          icon: MapPin,
        },
        {
          label: 'Kontakt',
          href: `/app/admin/producers/${producerId}/kontakt`,
          icon: Phone,
        },
        {
          label: 'Kategorier',
          href: `/app/admin/producers/${producerId}/kategorier`,
          icon: Tag,
        },
        {
          label: 'Bilder',
          href: `/app/admin/producers/${producerId}/bilder`,
          icon: ImageIcon,
        },
        {
          label: 'Publicering',
          href: `/app/admin/producers/${producerId}/publicering`,
          icon: Eye,
        },
      ],
    },
    {
      title: 'Funktioner',
      items: [
        {
          label: 'Gårdsbutik',
          href: `/app/admin/producers/${producerId}/shop`,
          icon: Store,
          requireCapability: 'farm_shop',
          children: [
            {
              label: 'Produkter',
              href: `/app/admin/producers/${producerId}/shop/products`,
              icon: Package,
            },
          ],
        },
        {
          label: 'Kurser & event',
          href: `/app/admin/producers/${producerId}/events`,
          icon: Calendar,
          requireCapability: 'events',
          comingSoon: true,
        },
      ],
    },
  ];
}
